import React from 'react';
import useAuth from '../../user/utils/auth/useAuth';
import styled, { css } from 'styled-components';
import { Anchor } from '../../common/interfaces';
import { useTranslation } from 'react-i18next';
import Popover from '../../common/components/basic/Popover';
import UserAvatar from '../../user/shared/components/UserAvatar';
import LanguagePopoverSelector from '../../common/components/form/LanguagePopoverSelector';

const MenuItem = styled.div<any>`
  margin: 0 10px;
  a {
    padding: 10px;
    font-size: 16px;
    color: inherit;
    transition: all ease-in-out 0.4s;
    &:hover {
      color: ${({ theme: { colors } }) => colors.primary.primary};
    }
  }

  ${props =>
    props.new &&
    css`
      a {
        border-radius: 5px;
        font-weight: bold;
        padding: 10px 15px;
        border: 1px solid ${({ theme: { colors } }) => colors.primary.primary};
        color: ${({ theme: { colors } }) => colors.primary.primary};
        transition: all ease-in-out 0.2s;

        :hover {
          background-color: ${({ theme: { colors } }) => colors.primary.primary};
          border: 1px solid ${({ theme: { colors } }) => colors.primary.primary};
          color: ${({ theme: { colors } }) => colors.light.primary};
          box-shadow: 0 1px 2px rgba(0, 0, 0, 0.15);
        }
      }
    `}
`;

const MenuItemVertical = styled(Anchor)`
  margin-top: 20px;
  padding: 0px 10px !important;
  display: block;
`;

export default function HeaderDesktop({ menus, authMenus, onLanguageChange = undefined }) {
  const { t } = useTranslation();
  const { user, isLoggedIn, logout } = useAuth();
  return (
    <div
      css={css`
        height: 80px;
        display: flex;
        justify-content: space-between;
        align-items: center;
      `}
    >
      <div>
        <Anchor href={'/'}>
          <img
            src="https://s3-ap-southeast-1.amazonaws.com/static.rupiahtoken.com/images/logo/logo-rpt.svg"
            className="logo"
            alt="RupiahToken logo"
            width={162}
          />
        </Anchor>
      </div>
      <div
        css={css`
          display: flex;
          align-items: center;
        `}
      >
        {menus.map((menu, idx) => (
          <MenuItem key={`desktop-${idx}`} new={menu.new}>
            <Anchor href={menu.link} dangerouslySetInnerHTML={{ __html: `${menu.label}` }} />
          </MenuItem>
        ))}
        {!isLoggedIn && (
          <MenuItem
            css={css`
              a {
                padding: 10px 20px;
              }
            `}
          >
            <Anchor type="button" outline circle href="/signin">
              {t('menu.login', 'Login')}
            </Anchor>
          </MenuItem>
        )}
        {isLoggedIn && (
          <MenuItem>
            <Popover
              arrow
              popoverContent={
                <div>
                  <MenuItem
                    css={css`
                      color: ${({ theme: { colors } }) => colors.dark.light};
                      margin-bottom: 10px;
                    `}
                  >
                    {user.email}
                  </MenuItem>
                  {authMenus.map(menu => (
                    <MenuItemVertical key={`menu-auth-${menu.label}`} href={menu.link}>
                      {menu.label}
                    </MenuItemVertical>
                  ))}
                  <MenuItemVertical onClick={() => logout()}>Logout</MenuItemVertical>
                </div>
              }
            >
              <UserAvatar user={user} />
            </Popover>
          </MenuItem>
        )}
        <MenuItem css={'padding-left: 0px;'}>
          <LanguagePopoverSelector onChange={onLanguageChange} />
        </MenuItem>
      </div>
    </div>
  );
}
